import { useQuery } from "@tanstack/react-query";
import {
  getManagerPayment,
  type ManagerPaymentParams,
} from "api/managerPayment";

export const managerPaymentKeys = {
  all: ["managerPayment"] as const,
  detail: (params: ManagerPaymentParams) =>
    [...managerPaymentKeys.all, params] as const,
};

export const useManagerPaymentQuery = (params: ManagerPaymentParams) =>
  useQuery({
    queryKey: managerPaymentKeys.detail(params),
    queryFn: () => getManagerPayment(params),
    enabled: !!params.seqPartner && !!params.referenceDate,
    staleTime: 30 * 1000,
  });
